<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Отправка уведомления о регистрации организации') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-3">
        <general-error v-if="!!generalError" />
        <v-progress-linear v-if="isLoading" color="loader" indeterminate />
        <v-alert
            v-test="{ alert: 'success' }"
            outlined
            :value="success"
            type="success">
          {{ $t('Сообщение отправлено') }}
        </v-alert>
        <ValidationObserver ref="emails">
          <validatable-mail-list
              v-model="emails"
              v-test="{ 'mail-list': 'email' }"
              rules="required"
              :label="$t('Адрес электронной почты')" />
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="!hasMails || isLoading"
            @click.stop="sendNotification">
          {{ $t('Отправить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableMailList from '@/components/reused/ui/ValidatableMailList.vue'
  import { mapActions } from 'vuex'
  import { ORGANIZATION_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableMailList
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => ({
          show: false,
          organizationId: null
        })
      }
    },
    data () {
      return {
        isLoading: false,
        success: false,
        emails: []
      }
    },
    computed: {
      hasMails () {
        return this.emails.length > 0
      }
    },
    methods: {
      ...mapActions(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        sendNotificationOfOrganizationAcceptanceAction: ORGANIZATION_MANAGEMENT.ACTIONS.SEND_NOTIFICATION_OF_ORGANIZATION_ACCEPTANCE
      }),
      sendNotification: async function () {
        try {
          const result = await this.$refs.emails.validate()
          if (!result) {
            throw new Vue.errorsTypes.ValidationError(this.$t('Выберите получателей сообщения'))
          }

          this.isLoading = true
          this.success = false
          await this.sendNotificationOfOrganizationAcceptanceAction({
            organizationId: this.dialogProp.organizationId,
            emails: this.emails
          })
          this.isLoading = false
          this.success = true
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
